import HomePage from '../Home';

const Login = ()=>{

return       <HomePage />

}

export default Login